module.exports = __webpack_public_path__ + "media/images/front/treatment_support/icon_feeling04_gray-a2bc7031e5f9819e58f427dcfcddbcd3.svg";